<template>
  <div>
    <b-modal
      :id="'Log1'+ index"
      title="รายการเหตุการณ์ความปลอดภัยแต่ละจุด"
      size="lg"
      ok-only
      ok-title="ปิด"
    >
      <b-row>
        <b-col lg="12">
          <b-row>
            <b-col
              lg="4"
            >
              <b-form-group>
                <v-select
                  v-model="date.type"
                  :reduce="optionType => optionType.analytic_type"
                  label="analytic_type"
                  class="deep style-chooser "
                  :options="optionType"
                  border-radius="6px;"
                  placeholder="เลือกเหตุการณ์"
                  transition=""
                  @input="clear"
                />
              </b-form-group>
            </b-col>
            <b-col
              class="d-flex align-items-center justify-content-end mb-1"
              lg="8"
            >
              <div class="d-flex align-items-center">
                <span class="mx-1">วันที่</span>
                <b-form-group class="flex-grow-1 mb-0">
                  <b-form-datepicker
                    v-model="date.dateFrom"
                    right
                    class="form-control"
                    style="width: 135px; border: 0px solid #000000;  background: #131313"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    locale="th"
                    @input="tableIncident('', date.type)"
                  />
                </b-form-group>
              </div>
              <div class="d-flex align-items-center">
                <span class="mx-1">ถึง</span>
                <b-form-group class="flex-grow-1 mb-0">
                  <b-form-datepicker
                    v-model="date.dateTo"
                    right
                    class="form-control"
                    style="width: 135px; border: 0px solid #000000;  background: #131313"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    locale="th"
                    @input="tableIncident('', date.type)"
                  />
                </b-form-group>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <!-- <b-col
              lg="4"
              class="mb-2"
            >
              <b-form-group>
                <v-select
                  v-model="date.type"
                  :reduce="optionType => optionType.iname"
                  label="iname"
                  class="deep style-chooser "
                  :options="optionType"
                  border-radius="6px;"
                  placeholder="เหตุการณ์ความปลอดภัยบนทางหลวง"
                  transition=""
                  @input="clear"
                />
              </b-form-group>
            </b-col> -->
            <!-- <b-col
              lg="5"
              class="mb-2"
            >
              <b-form-group>
                <v-select
                  v-model="date.location"
                  :reduce="optionLocation => optionLocation.location"
                  class="deep style-chooser "
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="optionLocation"
                  placeholder="จุดติดตั้งอุปกรณ์"
                  transition=""
                  size="md"
                  label="location"
                  @input="clear"
                />
              </b-form-group>
            </b-col> -->
            <!-- <b-col
              lg="3"
              class="mb-2"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-tour-skip mr-1"
                block
                @click="tableIncident(), filter = '', date.type = '', date.direction = '', date.location = '', date.status = ''"
              >
                <feather-icon
                  icon="FilterIcon"
                  size="14"
                />&nbsp;
                <span>รีเซ็ต</span>
              </b-button>
              <b-form-input
                id="filterInput"
                v-model="filter"
                hidden
                type="search"
                placeholder="ป้อนคำที่ต้องการค้นหา.."
                label-cols-sm="12"
                label-cols-md="2"
                label-cols-lg="2"
                style="background-color:rgba(255,255,255, 0.9);"
              />
            </b-col> -->
            <b-col cols="12">
              <b-table
                responsive
                :per-page="perPage"
                :current-page="currentPage"
                :items="items"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <!-- <template #cell(approval_name)="data">
                  {{ data.item.approval_name }}
                </template> -->
                <template #cell(filepath)="data">
                  <!-- v-b-modal="'Live1'"
                  @click="$refs.vdopath.streamLive(data.item.video_path)" -->
                  <b-link
                    v-b-modal="'Incidence2'"
                    @click="$refs.incidentpath.incidentDetail2(data.item.wid, data.item.tid, data.item.camid)"
                  >
                    <b-img
                      :src="data.item.filepath"
                      height="90px"
                    />
                  </b-link>
                </template>
                <template #cell(live)="data">
                  <!-- :to="{ path:`/datatraffic-detail?id=${data.item.id}` }" -->
                  <b-link
                    v-b-modal="'Incidence2'"
                    @click="$refs.incidentpath.incidentDetail2(data.item.wid, data.item.tid, data.item.camid)"
                  >
                    <b-img
                      title="กดเพื่อดูรายละเอียด"
                      height="25px"
                      src="@/assets/images/icons/info.png"
                    />
                  </b-link>
                </template>
                <!-- <template #cell(approval_status)="data">
                  <div v-if="data.item.approval_status === 0">
                    <b-button
                      variant="outline-warning"
                      size="sm"
                      @click=" approveStatus(data.item.id)"
                    >
                      รอการยืนยัน
                    </b-button>
                  </div>
                  <div v-if="data.item.approval_status === 1">
                    <b-badge variant="success">
                      เหตุการณ์จริง
                    </b-badge>
                  </div>
                  <div v-if="data.item.approval_status === 2">
                    <b-badge variant="secondary">
                      ไม่ใช่เหตุการณ์จริง
                    </b-badge>
                  </div>
                </template> -->
                <!-- <template #cell(incident_end_status)="data">
                  <div v-if="data.item.approval_status === 1 && data.item.incident_end_status === 0">
                    <b-badge variant="warning">
                      รอดำเนินการ
                    </b-badge>
                  </div>
                  <div v-if="data.item.approval_status === 1 && data.item.incident_end_status === 1">
                    <b-badge variant="primary">
                      เสร็จสิ้น
                    </b-badge>
                  </div>
                </template> -->
              </b-table>
            </b-col>
            <b-col
              cols="12"
            >
              <b-card-body class="d-flex justify-content-between flex-wrap pt-1">
                <!-- page length -->
                <b-form-group
                  label="Per Page"
                  label-cols="6"
                  label-align="left"
                  label-size="sm"
                  label-for="sortBySelect"
                  class="text-nowrap mb-md-0 mr-1"
                >
                  <b-form-select
                    id="perPageSelect"
                    v-model="perPage"
                    size="sm"
                    inline
                    :options="pageOptions"
                  />
                </b-form-group>

                <!-- pagination -->
                <div>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    first-number
                    last-number
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mb-0"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </div>
              </b-card-body>
            </b-col>
          </b-row>
          <Live
            ref="vdopath"
          />
          <Incidence2
            ref="incidentpath"
            @fetch="tableIncident()"
          />
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {
  BRow, BCol, BImg, BFormGroup, BFormSelect, BFormDatepicker,
  BTable, BLink, BCardBody, BPagination,
  BModal,
  // BButton, BFormInput,
  // BBadge,
} from 'bootstrap-vue'
import axios from '@axios'
import vSelect from 'vue-select'
import Live from './LiveRTSPvideo.vue'
import Incidence2 from './IncidenceModal2.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BPagination,
    BFormDatepicker,
    BLink,
    // BFormInput,
    // BButton,
    BFormGroup,
    BFormSelect,
    BCardBody,
    BImg,
    BModal,
    // BBadge,
    vSelect,
    Live,
    Incidence2,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      index: '',
      date: {
        type: '',
        wid: '',
        dateFrom: '',
        dateTo: '',
        month: new Date().getFullYear(),
        year: 1,
      },
      optionType: [],
      fields: [

        // {
        //   key: 'id',
        //   label: 'ลำดับ',
        //   class: 'text-center',
        // },
        {
          key: 'date_time',
          label: 'วันเวลา',
          class: 'text-center',
        },
        {
          key: 'filepath',
          label: 'ภาพเหตุการณ์',
          class: 'text-center',
        },
        {
          key: 'incident_type',
          label: 'เหตุการณ์',
          class: 'text-center',
        },
        {
          key: 'STA',
          label: 'จุดติดตั้ง',
          class: 'text-center',
        },
        {
          key: 'camid',
          label: 'กล้องที่',
          class: 'text-center',
        },
        {
          key: 'live',
          label: 'รายละเอียด',
          class: 'text-center',
        },
        // {
        //   key: 'approval_status',
        //   label: 'ยืนยันเหตุการณ์',
        //   class: 'text-center',
        // },
        // {
        //   key: 'incident_end_status',
        //   label: 'สถานะ',
        //   class: 'text-center',
        // },
      ],
      userData: JSON.parse(localStorage.getItem('userData')),
      items: [],
      perPage: 5,
      pageOptions: [5, 50, 75, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      status: [{
        Online: 'Online', Offline: 'Offline',
      },
      {
        Online: 'success', Offline: 'danger',
      }],
      startMonth: 2020,
      endMonth: new Date().getFullYear(),
      startYear: 1,
      endYear: 5,

      Slows_Down: '0',
      Road_Construction: '0',
      Blocking_Road: '0',
      Accident: '0',
      Broke_Down: '0',
      No_Parking: '0',
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    monthList() {
      const years = []
      // eslint-disable-next-line no-plusplus
      for (let i = this.endMonth; i >= this.startMonth; i--) {
        years.push(i)
      }
      return years
    },
    yearList() {
      const years = []
      // eslint-disable-next-line no-plusplus
      for (let i = this.endYear; i >= this.startYear; i--) {
        years.push(i)
      }
      return years
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.date.wid = this.$route.query.wid
    this.setToday()
    this.dropdownType()
    // this.dropdownLocation()
    // this.dropdownDirection()
    // this.dropdownStatus()
    // this.interval = setInterval(() => {
    //   this.tableIncident()
    // }, 600000)
  },
  methods: {
    clear(value) {
      if (value === null) {
        this.filter = '' // กำหนดให้กลับไปเป็นค่าเริ่มต้นที่ต้องการ
      } else {
        this.tableIncident()
        this.filter = value
      }
    },
    tableIncident(index, type) {
      this.index = index
      this.date.type = type
      this.items = []
      if (this.$route.query.type !== '0') {
        axios
          .post('/getTableIncident-G', this.date)
          .then(response => {
            this.items = response.data
            this.camid = response.data.camid
            if (type) {
              const validData = response.data.filter(item => item.incident_type === type) // Filter out zero values
              this.items = validData.map(item => ({
                incident_type: item.incident_type,
                tid: item.tid,
                date_time: item.date_time,
                wid: item.wid,
                createdate: item.createdate,
                camid: item.camid,
                STA: item.STA,
                filepath: item.filepath,
                videopath: item.videopath,
                ipaddress: item.ipaddress,
              }))
              this.totalRows = this.items.length
            } else {
              this.items = response.data
              this.totalRows = this.items.length
              this.camid = response.data.camid
            }
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getTableIncident', this.date)
          .then(response => {
            this.items = response.data
            this.camid = response.data.camid
            if (type) {
              const validData = response.data.filter(item => item.incident_type === type) // Filter out zero values
              this.items = validData.map(item => ({
                incident_type: item.incident_type,
                tid: item.tid,
                date_time: item.date_time,
                wid: item.wid,
                createdate: item.createdate,
                camid: item.camid,
                STA: item.STA,
                filepath: item.filepath,
                videopath: item.videopath,
                ipaddress: item.ipaddress,
              }))
              this.totalRows = this.items.length
            } else {
              this.items = response.data
              this.totalRows = this.items.length
              this.camid = response.data.camid
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    dropdownType() {
      axios
        .post('/dropdownTypeAI')
        .then(response => {
          this.optionType = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    setToday() {
      const today = new Date()
      const pastDate = new Date(today)
      pastDate.setDate(today.getDate() - 6)

      const formatDate = date => {
        const month = (`0${date.getMonth() + 1}`).slice(-2)
        const year = date.getFullYear()
        const dateTo = (`0${date.getDate()}`).slice(-2)
        return `${year}-${month}-${dateTo}`
      }

      this.date.dateFrom = formatDate(pastDate)
      this.date.dateTo = formatDate(today)
    },
    // approveStatus(value) {
    //   this.$swal({
    //     title: '<span style="color:#ffffff; text-align: left;">ยืนยันเหตุการณ์</span>',
    //     html: '<span style="color:#ffffff">เหตุการณ์ที่เกิดขึ้นเป็นเหตุการณ์จริงหรือไม่</span>',
    //     background: 'rgba(33, 33, 33, 1)',
    //     showDenyButton: true,
    //     showCancelButton: false,
    //     showCloseButton: true,
    //     width: '600px',
    //     height: '500px',
    //     confirmButtonText: 'เหตุการณ์จริง',
    //     denyButtonText: 'ไม่ใช่เหตุการณ์จริง',
    //     customClass: {
    //       confirmButton: 'btn btn-primary mr-5',
    //       cancelButton: 'btn btn-warning',
    //       denyButton: 'btn btn-danger',
    //       actions: 'swal2-actions-custom', // Class นี้จะถูกใช้สำหรับ styling
    //     },
    //     onOpen: () => {
    //       const actions = document.querySelector('.swal2-actions')
    //       const footer = document.querySelector('.swal2-footer')
    //       if (footer) {
    //         footer.appendChild(actions)
    //       }
    //     },
    //     footer: '<div></div>', // เพิ่ม footer ว่างเปล่าให้กับ SweetAlert
    //   }).then(result => {
    //     if (result.isConfirmed) {
    //       axios
    //         .post('https://khuntan-api.hwpd.go.th/approve-Status', {
    //           id: value, approval_status: 1, prefix: this.userData.prefix, firstname: this.userData.firstname, lastname: this.userData.lastname, idcard: this.userData.idcard,
    //         })
    //         .then(response => {
    //           console.log(response)
    //           this.$swal({
    //             icon: 'success',
    //             title: '<span style="color:#000000">ยืนยันเหตุการณ์สำเร็จ</span>',
    //             showConfirmButton: false,
    //             timer: 1000,
    //           })
    //           this.tableIncident()
    //         })
    //         .catch(error => {
    //           console.log(error)
    //           this.$swal({
    //             icon: 'error',
    //             text: error.response.data.message,
    //             showConfirmButton: false,
    //             timer: 2000,
    //           })
    //         })
    //     } else if (result.isDenied) {
    //       axios
    //         .post('https://khuntan-api.hwpd.go.th/approve-Status', {
    //           id: value, approval_status: 2, prefix: this.userData.prefix, firstname: this.userData.firstname, lastname: this.userData.lastname, idcard: this.userData.idcard,
    //         })
    //         .then(response => {
    //           console.log(response)
    //           this.$swal({
    //             icon: 'success',
    //             title: '<span style="color:#000000">ยืนยันเหตุการณ์สำเร็จ</span>',
    //             showConfirmButton: false,
    //             timer: 1000,
    //           })
    //           this.tableIncident()
    //         })
    //         .catch(error => {
    //           console.log(error)
    //           this.$swal({
    //             icon: 'error',
    //             text: error.response.data.message,
    //             showConfirmButton: false,
    //             timer: 2000,
    //           })
    //         })
    //     }
    //   })
    // },
  },
}
</script>

  <style lang="scss" scoped>

  .table-responsive{
     font-size: 15px;
  }
  .table th{
     padding: 0.72rem;
  }
  .table td{
     padding: 0.72rem;
  }
  .vue2leaflet-map{
    &.leaflet-container{
      height: 200px;
    }
  }
  .leaflet-popup-content {
    margin: 10px 10px;
  }
  .leaflet-container a.leaflet-popup-close-button {
    padding: 0 0 0 0
  }
  </style>
